<template>
    <div>
        <v-menu offset-y v-if="loggedin && $store.state.cognito.user">
            <template v-slot:activator="{ on }">
                <v-btn
                        dark
                        text
                        v-on="on"
                >
                    <v-icon>{{$store.state.icons.cogs}}</v-icon>
                </v-btn>
            </template>
            <v-list two-line nav v-if="myorgs">

                <v-list-item
                        v-for="(item, index) in myorgs"
                        :key="index"
                        @click="loadOrg(item)"
                >
                    <v-list-item-avatar>
                        <v-img v-if="item.logo" :src="item.logo" />
                        <v-icon v-else>{{$store.state.icons.user}}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.name }}</v-list-item-title>
                        <v-list-item-subtitle v-if="$store.state.appdata.orgdefault && $store.state.appdata.orgdefault.partkey===item.partkey">Default</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="$store.state.org.partkey===item.partkey">
                        <v-btn icon text>
                            <v-icon color="green">{{$store.state.icons.checkon}}</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>

                <v-list-item v-if="$store.state.cognito.user.attributes">
                    <v-list-item-title>{{$store.state.cognito.user.attributes.email}}</v-list-item-title>
                </v-list-item>

                <v-list-item
                        key="logout"
                        @click="$router.replace('/'), $store.dispatch('signout')">
                    <v-list-item-title>Sign Out</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <BaseBtn
                text
                v-else
                to="/auth/signin"
        >
            Sign In
        </BaseBtn>
        <BaseBtn
                v-if="!loggedin"
                to="/auth/signup"
        >
            Sign Up
        </BaseBtn>
        <v-dialog v-model="dialog" persistent max-width="350">
            <v-card v-if="!loading">
                <v-card-title>
                    Load Organization
                </v-card-title>
                <v-card-text>
                    <img :src="activeorg.logo" width="80" />
                    Confirm load {{activeorg.name}} ?
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="dialog=false,activeorg=false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text @click="confirmLoadOrg()" :loading="loading">Confirm</v-btn>
                </v-card-actions>
            </v-card>
            <v-btn large :loading="loading"></v-btn>
        </v-dialog>
    </div>
</template>

<script>
  import{
      mapState,
      mapActions,
      mapMutations
  }from 'vuex'
  export default {
    components: {},
    name: "NavMenue",
    data() {
      return {
        dialog: false,
        activeorg: false,
        loading: false
      }
    },
    computed:{
      ...mapState(['icons','myorgs','loggedin','org','isReady']),
      logo(){
        return (this.org)?(this.org.info.small_logo||this.org.info.logo):'/img/icons/apple-touch-icon-60x60.png'
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions(['post','getAppData']),
      loadOrg(item){
        if(this.$store.state.org.partkey!==item.partkey){
          this.activeorg=item
          this.dialog=true
        } else {
          this.$router.push('/organization')
        }
      },
      async confirmLoadOrg(){
        //sets the 'default o new org, then loads default
        this.loading=true;
        await this.post({path:'api/orgs/setdefault',body:{orgkey:this.activeorg.partkey}})
        this.loading=false
        this.getAppData()
        this.activeorg=false
        this.dialog=false
      },
    }
  }
</script>

<style scoped>

</style>